import React, {useEffect, useState} from 'react'
import {useLocation} from "react-router-dom";
import FromFieldText from '../../atoms/FromFieldText';
import {getCompanyProfileList, getFinancialYearInfo, saveFinancialYear} from '../../services/user.service';
import * as CryptoJS from "crypto-js";
import Select from "react-select";

const TEXT_REGEX = /^[a-zA-Z0-9-_ ]{1,255}$/;

function AddFinancialYear() {

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    const [companyId, setCompanyId] = useState('');
    const [ErrCompanyId, setErrCompanyId] = useState(false);

    const [financialYearName, setFinancialYearName] = useState('');
    const [ErrFinancialYearName, setErrFinancialYearName] = useState(false);

    const [companies, setCompanies] = useState([]);

    const [selectedYearOptions, setSelectedYearOptions] = useState(null);
    const [ErrFinancialYear, setErrFinancialYear] = useState(false);

    const [financialStatus, setFinancialStatus] = useState('');
    const [ErrFinancialStatus, setErrFinancialStatus] = useState(false);
    const generateYearOptions = () => {
        return Array.from({length: new Date().getFullYear() - 1999}, (_, i) => ({
            value: 2000 + i,
            label: 2000 + i
        }));
    };
    const optionListYear = generateYearOptions();
    const resetUserInfo = function () {
        setFinancialYearName('');
        setCompanyId('');
    }

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Division_Id = query.get('financialYear_id');

    useEffect(() => {
        if (Division_Id !== '' && Division_Id != null) {
            const decryptedBytes = CryptoJS.AES.decrypt(Division_Id.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            // Convert the decrypted bytes to a string
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            const DivisionId = decrypt_data.financialYear_id;
            getDivisionData(DivisionId);
        }
        //encrypted data
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            //'param_data':obj,
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = {'token': EncryptData}
        getCompanyProfileList(oData).then(res => {
            if (res?.data?.data?.length) setCompanies(res.data.data);
        })
    }, [])
    const getDivisionData = function (DivisionId) {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'financials_id': DivisionId},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData1 = {'token': EncryptData}

        getFinancialYearInfo(oData1).then(function (res) {
            if (res?.data?.data) {
                var divisInfo = res.data.data[0];
                setCompanyId(divisInfo.company_id);
                setFinancialYearName(divisInfo.financialYearName);
                setFinancialStatus(divisInfo.status);
                // Ensure selectedYearOptions is in the correct format
                setSelectedYearOptions({
                    value: divisInfo.financialYear,
                    label: divisInfo.financialYear
                });
            }
        })
    }
    const handleCompanyId = (e) => {
        setCompanyId(e.target.value);
    }
    const handleStatus = (e) => {
        setFinancialStatus(e.target.value);
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        var valid_Name = true;
        if (!TEXT_REGEX.test(companyId)) { //alert(name);
            setErrCompanyId('Company name is required');
            valid_Name = false;
        } else {
            setErrCompanyId('');
        }
        if (!TEXT_REGEX.test(financialYearName)) { //alert(name);
            setErrFinancialYearName('Financial year name is required');
            valid_Name = false;
        } else {
            setErrFinancialYearName('');
        }
        if (!selectedYearOptions || !TEXT_REGEX.test(selectedYearOptions.value.toString())) {
            setErrFinancialYear('Financial year is required');
            valid_Name = false;
        } else {
            setErrFinancialYear('');
        }
        if (!TEXT_REGEX.test(financialStatus)) { //alert(name);
            setErrFinancialStatus('Status is required');
            valid_Name = false;
        } else {
            setErrFinancialStatus('');
        }
        if (valid_Name) {
            saveData();
        } else {
            return false;
        }
    }

    const saveData = function () {
        try {

            if (Division_Id !== '' && Division_Id !== null) {
                const decryptedBytes = CryptoJS.AES.decrypt(Division_Id.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                // Convert the decrypted bytes to a string
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                const decryptedDivId = decrypt_data.division_id;
                var obj = {
                    'div_id': decryptedDivId,
                    'financialYearName': financialYearName,
                    'financialYear': selectedYearOptions,
                    'company_id': companyId,
                    'status': financialStatus,
                    'created_by': sessionStorage.getItem('LoggedInUserId'),
                    'department_id': sessionStorage.getItem('LoggedInDepartmentId'),
                    'division_id': sessionStorage.getItem('LoggedInDivisionId'),
                }
            } else {
                var obj = {
                    'financialYearName': financialYearName,
                    'financialYear': selectedYearOptions,
                    'company_id': companyId,
                    'status': financialStatus,
                    'created_by': sessionStorage.getItem('LoggedInUserId'),
                    'department_id': sessionStorage.getItem('LoggedInDepartmentId'),
                    'division_id': sessionStorage.getItem('LoggedInDivisionId'),
                }
            }


            //encrypted data
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = {'token': EncryptData}

            saveFinancialYear(oData).then(function (res) {
                //console.log(res);
                if ((typeof (res.data.errors) != "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    resetUserInfo();
                }
            });

            //setValidName(false);
        } catch (err) {
            setSuccess(false);
            if (!err?.data) {
                //console.log(err);
                setErrMsg('No Server Response');
            } else if (err.data?.status === 409) {
                setErrMsg('data already exist');
            } else {
                setErrMsg('Insert/Update Failed');
            }
            //elementRef.current.focus();
        }
    }
    const handleYearAddition = (selectedOption) => {
        setSelectedYearOptions(selectedOption);
    };

    return (
        <div className="container">

            <div className="row">
                <div className="col-6">
                    <h5>Add Financial Year</h5>
                </div>
                <div className="invalid-feedback" role="alert">
                    <i className="fa fa-info-circle"></i>
                    Please Fill all mandatory field.
                </div>

                {success ? (
                    <div className="alert alert-success" role="alert"><i
                        className="bi bi-check-circle-fill"></i>{success}</div>
                ) : (errMsg ? (<div className="alert alert-danger" role="alert"><i
                        className="bi bi-exclamation-triangle-fill"></i>{errMsg}</div>) : ('')
                )}
            </div>

            <div className='row '>
                <div className='col-12'>&nbsp;</div>

            </div>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="label col-3">
                        <label>Company </label><span className="star error"> *</span>
                    </div>

                    <div className="item col-3">
                        <select className="form-select form-select-sm mb-3" value={companyId}
                                onChange={handleCompanyId}>
                            <option value="">Select Company</option>
                            {companies.map((option) => (
                                <option key={option.company_id} value={option.company_id}>
                                    {option.company_name}
                                </option>
                            ))}
                        </select>
                        <span className="invalid-feedback"> {ErrCompanyId} </span>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6">
                        <FromFieldText star="*"
                                       label="Financial Year Name"
                                       inputValue={financialYearName}
                                       setInputValue={setFinancialYearName}
                                       setErrorMsg={ErrFinancialYearName}
                        />
                    </div>
                    <div className="col-6"></div>
                    <div className="col-6"></div>
                </div>
                <div className="row form-fields mt-2">
                    <div className="label col-3">
                        <label>Financial Year </label><span className="star error"> *</span>
                    </div>

                    <div className="item col-3">
                        <Select
                            options={optionListYear}
                            placeholder="Select One"
                            value={selectedYearOptions}
                            onChange={handleYearAddition}
                        />
                        <span className="invalid-feedback"> {ErrFinancialYear} </span>
                    </div>
                </div>
                <div className="row form-fields mt-2">
                    <div className="label col-3">
                        <label>Status </label><span className="star error"> *</span>
                    </div>

                    <div className="item col-3">
                        <select className="form-select form-select-sm mb-3" value={financialStatus}
                                onChange={handleStatus}>
                            <option value="">Select Status</option>
                            <option value="1">Active</option>
                            <option value="2">Inactive</option>
                        </select>
                        <span className="invalid-feedback"> {ErrFinancialStatus} </span>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-3"></div>
                    <div className="col-6">
                        <button className="btn btn-primary  btn-sm"> SAVE</button>
                    </div>
                    <div className="col-3"></div>
                </div>
            </form>
        </div>
    )
}

export default AddFinancialYear


